import { useAuth } from '@hb/react'
import { useMemo } from 'react'
import { usePatientDocuments } from './usePatientDocuments'

export const useUnreadDocuments = () => {
  const { user } = useAuth()
  const { data } = usePatientDocuments(user?.id)
  return useMemo(
    () =>
      Object.entries(data ?? {})
        .filter(([, doc]) => !doc.viewedOn)
        .map(([id, doc]) => ({
          id,
          ...doc,
        })),
    [data],
  )
}
